import { AppBanner } from "@circle-react/components/AppBanner";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { getCommunityLogoUrlAndType } from "@circle-react/helpers/communityHelpers";
import { useCanSwitchCommunities } from "@circle-react/hooks/community_switcher/useCanSwitchCommunities";
import { useThemeContext } from "@circle-react/providers/Theme";
import { Drawer } from "@circleco/compass/components/Drawer";
import { MobileShell } from "@circleco/compass/components/MobileShell";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { MobileCommunitySwitcherDrawerContent } from "./drawers/MobileCommunitySwitcherDrawerContent";
import { useMobileChromeVisibility } from "./hooks/chrome/useMobileChromeVisibility";
import type { MobileLayoutShellProps } from "./MobileLayoutShell";
import { MobileShellInner } from "./shell/MobileShellInner";

export const MobileLayoutShellInner = ({
  children,
}: MobileLayoutShellProps) => {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const { isDarkAppearance } = useThemeContext();
  const communityName = currentCommunity?.name ?? "Circle";
  const { url: logoUrl } = getCommunityLogoUrlAndType(
    currentCommunity,
    isDarkAppearance,
  );
  const { isHideChromeOnScrollDisabled } = useMobileChromeVisibility();
  const canSwitchCommunities = useCanSwitchCommunities();

  const [isSwitcherOpen, setIsSwitcherOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <MobileShell.Root hideChromeOnScroll={!isHideChromeOnScrollDisabled}>
      <AppBanner />

      {/* Community switcher drawer - controlled via onTitleClick */}
      {canSwitchCommunities && (
        <Drawer.Root open={isSwitcherOpen} onOpenChange={setIsSwitcherOpen}>
          <Drawer.Content aria-label={t("mobile_shell.switch_community")}>
            <MobileCommunitySwitcherDrawerContent
              onClose={() => setIsSwitcherOpen(false)}
            />
          </Drawer.Content>
        </Drawer.Root>
      )}

      <MobileShellInner
        communityName={communityName}
        logoUrl={logoUrl ?? undefined}
        avatarName={currentCommunityMember?.name ?? ""}
        avatarUrl={currentCommunityMember?.avatar_url ?? undefined}
        onTitleClick={
          canSwitchCommunities ? () => setIsSwitcherOpen(true) : undefined
        }
        isNavOpen={isNavOpen}
        setIsNavOpen={setIsNavOpen}
      >
        {children}
      </MobileShellInner>
    </MobileShell.Root>
  );
};
